module.exports = __webpack_public_path__ + "static/media/aces_s_on.59e3bcac.svg";